import ConsentArea from './ConsentArea';

export default ConsentArea;
